"use strict";

exports.__esModule = true;
exports.darkThemeOptions = exports.createTheme = void 0;

var breakpoints_1 = require("./breakpoints");

var colors_1 = require("./colors");

var palette_1 = require("./palette");

var typography_1 = require("./typography");

exports.createTheme = function (options) {
  if (options === void 0) {
    options = {};
  }

  var breakpoints = breakpoints_1.createBreakpoints(options.breakpoints);
  var typography = typography_1.createTypography(options.typography, breakpoints);
  var palette = palette_1.createPalette(options.palette);
  return {
    breakpoints: breakpoints,
    typography: typography,
    palette: palette
  };
};

exports.darkThemeOptions = {
  palette: {
    text: {
      primary: colors_1.colors.white,
      secondary: colors_1.colors.gray60
    },
    background: {
      "default": '#293a40',
      paper: '#07232b',
      shadow: '#455960',
      dimmed: '#182b31'
    }
  }
};